/**
 * Testimonials slider script
 */
class CreationsPaint_Testimonials {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        let sliderWrapper = $('.block-testimonials');
        let nextBtn = sliderWrapper.find('.next');

        setTimeout(() => {
            showNextSlide();
        }, 4500);

        if (sliderWrapper.length) {
            let list = sliderWrapper.find('.testimonial-list');
            let items = list.find('.testimonial-item');
            let currentItem = 0;
            let animationInProgress = false;

            nextBtn.on('click', function(e) {
                e.preventDefault();

                if (animationInProgress) {
                    return;
                }

                currentItem++;
                animationInProgress = true;

                if (currentItem >= items.length) {
                    currentItem = 0;
                }

                items.removeClass('is-active');
                setTimeout(function() {
                    items.eq(currentItem).addClass('is-active');
                }, 550);

                setTimeout(function() {
                    animationInProgress = false;
                }, 550);
            });
        }

        function showNextSlide () {
            nextBtn.trigger('click');

            setTimeout(() => {
                showNextSlide();
            }, 4500);
        }
    }
}